import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { NavMobile } from '../Components/Inicio/NavMobile';
import { FallaInfo } from '../Components/Inicio/FallaInfoComponent';
import { Footer } from '../Components/Footer/FooterComponent';
import EmblaCarousel from '../Components/Inicio/EmblaCarousel';

import Imagea1 from '../Assets/Images/Manos_Portada.jpg';
import Imagea2 from '../Assets/Images/Crema4.jpg';
import Imagea3 from '../Assets/Images/MareaNaranja.jpg';
import Imagea4 from '../Assets/Images/crema1.jpg';
import Imagea5 from '../Assets/Images/PremiosFalla.jpg';
import { getActiveProfileToken } from '../utils/profileStorage';
import { GetSiteContent } from '../Backend/ApiCalls';

const OPTIONS = { loop: true };

export const Home = (props) => {
  const navigate = useNavigate();
  const [representativesCover, setRepresentativesCover] = useState(null);

  useEffect(() => {
    let active = true;
    GetSiteContent()
      .then(({ response, data }) => {
        const imageUrl = data?.homepage?.representativesCover?.imageUrl;
        if (active && response.ok && typeof imageUrl === 'string' && imageUrl) setRepresentativesCover(imageUrl);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  useEffect(() => {
    try {
      const token = getActiveProfileToken();
      const redirectedThisSession = sessionStorage.getItem('redirectedToProfileThisSession');

      // Si hay token y todavía no redirigimos en esta sesión -> redirigir
      if (token && !redirectedThisSession) {
        // marcar que ya redirigimos en esta sesión para evitar loops
        sessionStorage.setItem('redirectedToProfileThisSession', 'true');

        // evitar navegar si ya estamos en /perfil (seguridad)
        if (window.location.pathname !== '/perfil') {
          navigate('/perfil');
        }
      }
    } catch (e) {
      console.warn('Error comprobando redirección inicial:', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]); // solo al montar

  return (
    <>
      <LogoHeader I18n={props.I18n} />
      <NavDesktop I18n={props.I18n} />
      <NavMobile I18n={props.I18n} />
      <EmblaCarousel images={[representativesCover || Imagea1, Imagea2, Imagea3, Imagea4, Imagea5]} options={OPTIONS} />
      <FallaInfo I18n={props.I18n} />
      <Footer I18n={props.I18n} />
    </>
  );
};
